import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {RestService} from '../shared/rest/rest.service';
import {AlertService} from '../shared/alert.service';
import {AnimationUtil} from '../shared/material/animation-util';

@Component({
  selector: 'app-remind-password',
  templateUrl: './remind-password.component.html',
  styleUrls: ['./remind-password.component.scss'],
  animations: [AnimationUtil.submitButtonAnimation]
})
export class RemindPasswordComponent implements OnInit {

  inProgress = false;
  success = false;

  remindForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.minLength(3), Validators.email]),
    username: new FormControl('', [Validators.required, Validators.minLength(3)]),
    domain: new FormControl('', [])
  });

  constructor(
      public router: Router,
      private restService: RestService,
      private alertService: AlertService,
  ) {
  }

  ngOnInit(): void {
  }

  remind() {
    this.inProgress = true;
    this.restService.remind(this.remindForm.value.email, this.remindForm.value.username, this.remindForm.value.domain)
        .subscribe(response => {
          this.success = true;
          this.router.navigate(['boslogin', 'logout']);
        }, error => {
          this.alertService.error('remind.error');
          this.inProgress = false;
          this.success = false;
          console.error(error);
        });
  }
}
